<div class="w-full mb-4" [formGroup]="formGroup()">
  <div class="flex flex-row w-128">
    <p class="flex flex-col">
        <p-floatlabel variant="in">
            <p-inputmask class="mr-4" formControlName="code" id="code" mask="999999999999999" placeholder="999999999999999" />
            <label for="code">{{ "chipRegistration.chipSearch.microchipCode" | translate }}</label>
        </p-floatlabel>
    </p>
    @if (isRegistration()) {
        <p-button
            severity="secondary"
            size="small"
            styleClass="h-full text-xl"
            type="button"
            [disabled]="!formGroup().get('code')?.valid"
            [label]="'chipRegistration.chipSearch.buttonLabel' | translate"
            (click)="searchButtonClicked()" />
    }
  </div>
    @if (isChipAlreadyUsed) {
        <p-message severity="error" size="small" variant="simple">
            {{ "chipRegistration.chipSearch.chipAlreadyUsed" | translate }}
        </p-message>
    }
    @if (formGroup().get('code')?.hasError('invalidCode15')) {
        <p-message severity="error" size="small" variant="simple">
            {{ "chipRegistration.chipSearch.invalidCode15" | translate }}
        </p-message>
    }
</div>
